export default __webpack_public_path__ + "static/burger-sorry-2dfa65559357d1513c2ef12c585379a2.png";